import React from 'react'
import { AppFormItem as AppFormItemProps } from 'api/index'
export interface AppTextAreaProps {
	value?: string
	placeholder?: string
	onChange?: (value: string) => void
	width?: number | string
	rows?: number
}
export default class AppTextArea extends React.Component<AppTextAreaProps> {
	state = { value: this.props.value, onfocus: false }
	getValue = () => {
		return this.state.value
	}

	change = (e: any) => {
		let value = e.target.value
		this.setState({ value })
	}
	handleOnFocus = () => {
		this.setState({ onfocus: true })
	}
	handleValueChg = () => {
		let value = this.state.value
		// this.props.onChange && this.props.onChange(value);
		this.setState({ value, onfocus: false })
	}

	shouldComponentUpdate() {
		if (this.props.value !== this.state.value && this.state.onfocus === false) {
			const newtext = this.props.value
			this.setState({ value: newtext })
			return true
		}
		if (this.state.onfocus === false && this.props.value === this.state.value) return false
		return true
	}

	render() {
		let { value } = this.state
		return (
			<textarea
				placeholder={this.props.placeholder || ''}
				value={value || ''}
				rows={this.props.rows || 3}
				onChange={this.change}
				data-value={this.state.value}
				className="ant-input app-input"
				onBlur={this.handleValueChg}
				onFocus={this.handleOnFocus}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/AppFormItem/AppTextArea.tsx